export default {
  container: {
    mobile: null,
    tablet: null,
    default: 960,
    large: 1170,
  },
};
